import { saveBilling } from '@webapps/business';
import { useAuth, useMutation, useToast, FormikAutocompletePx, FormikTextFieldPx } from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import { useEffect, useState,  useRef } from 'react';
import { useFormik } from 'formik';
;
import { Button, ButtonBase, Divider, FormLabel, Grid } from '@material-ui/core';
import { AddRounded, CloseRounded } from '@material-ui/icons';

const GenerateBilling = ({ opcoRecord, refetch }) => {
  const { classes, css, cx, theme: { spacing }, global } = useStyles(styles);

    const { idUser } = useAuth();
    const { addToast } = useToast();

    const formik = useFormik({
      initialValues: {
        totalAmount: '',
        lines: [{
          amount: '',
          quantity: '',
          dueDate: '',
          billingType: {
            label: 'Frais de transport',
            value: 'MOBILITE'
          }
        }]
      },
      onSubmit: (values) => {
        const totalAmount = values.lines.reduce((acc, ligne) => {
          const amount = parseFloat(ligne.amount) || 0;
          const quantity = parseFloat(ligne.quantity) || 0;
          return acc + (amount * quantity);
        }, 0);
    
        formik.setFieldValue('totalAmount', totalAmount);

        mutateSaveBilling({ id: opcoRecord?.id, data: {
            totalAmount,
            lines: values.lines.map(ligne => ({
              ...ligne,
              billingType: ligne.billingType.value
            }))
          }
        });
      }
    });

    const {
      error: errorSaveBilling,
      isLoading: isLoadingSaveBilling,
      isSuccess: isSuccessSaveBilling,
      mutateAsync: mutateSaveBilling,
    } = useMutation(saveBilling);


    useEffect(() => {
      if (isSuccessSaveBilling) {
        addToast({
          status: 'success',
          message: 'La facture a été généré avec succès',
        });
        refetch()
        formik.resetForm();
      } else if (errorSaveBilling) {
        console.log(errorSaveBilling?.response)
        addToast({
          status: 'error',
          message: `Une erreur est survenue lors de la génération de la facture : ${errorSaveBilling?.response?.data?.description || ''}`,
        });
      }
      
    }, [errorSaveBilling, isSuccessSaveBilling]);

    const handleAddLigne = () => {
      formik.setFieldValue('lines', [
        ...formik.values.lines,
        { amount: '', quantity: '', dueDate: '', billingType: { label: 'Frais de transport', value: 'MOBILITE' } }
      ]);
    };
  
    const handleRemoveLigne = (v) => {
      if(formik.values.lines.length == 1){
        return;
      }
      formik.setFieldValue('lines', formik.values.lines.filter((ligne, index) => index !== v));
    };

    const NATURE_LIGNE = [
      { label: "Frais de transport", value: "MOBILITE" },
      { label: "Frais de restauration", value: "RESTAURATION" },
      { label: "Frais d'hebergement", value: "HEBERGEMENT" },
      { label: "Frais d'équipement", value: "PREMIEREQUIPEMENT" },
      { label: "Frais pédagogique", value: "PEDAGOGIE" },
      { label: "Frais RQTH", value: "MAJORATION_RQTH" },
    ]
  
  return (
    <div className={global.recordSection}>
      <div className={cx(global.title, global.blueBar)}>Générer une facture</div>
      {formik.values.lines.map((ligne, index) => (
        <div>
          <Divider key={index} className={classes.divider} />
          <div className={global.frac}>
            <div className={classes.ligne}>{formik.values.lines.length > 1 && 
              <ButtonBase onClick={() => handleRemoveLigne(index)} className={cx(global.buttonBase, css({ backgroundColor: "white" }))}>
                <CloseRounded className={global.buttonIcon} />
              </ButtonBase>
              } 
              LIGNE {index + 1} 
            </div>
            <Grid container xs={12} spacing={2}>
              <Grid item xs={3} className={global.formikTextFieldWhite}>
                <FormLabel>Montant</FormLabel>
                <FormikTextFieldPx
                  formik={formik}
                  fullWidth
                  placeholder="1"
                  name={`lines[${index}].amount`}
                  type="number"
                  value={formik.values.lines[index].amount}
                />
              </Grid>
              <Grid item xs={3} className={global.formikTextFieldWhite}>
                <FormLabel>Quantité</FormLabel>
                <FormikTextFieldPx
                  formik={formik}
                  fullWidth
                  placeholder="1"
                  name={`lines[${index}].quantity`}
                  type="number"
                  value={formik.values.lines[index].quantity}
                />
              </Grid>
              <Grid item xs={3} className={global.formikTextFieldWhite}>
                <FormLabel>Nombre d'échéance</FormLabel>
                <FormikTextFieldPx
                  formik={formik}
                  fullWidth
                  placeholder="1"
                  name={`lines[${index}].dueDate`}
                  type="number"
                  value={formik.values.lines[index].dueDate}
                />
              </Grid>
              <Grid item xs={3} className={global.formikTextFieldWhite}>
                <FormLabel>Nature de ligne</FormLabel>
                <FormikAutocompletePx
                  formik={formik}
                  options={NATURE_LIGNE}
                  getOptionLabel={(option) => option.label || ''}
                  fullWidth
                  disableClearable
                  placeholder="Frais de transport"
                  name={`lines[${index}].billingType`}
                  value={NATURE_LIGNE.find((option) => option.value === formik.values.lines[index].billingType.value) || ""}
                />
              </Grid>
            </Grid>
          </div>
        </div>
      ))}
      <div className={cx(global.fcab, css({ gap: 16 }))}>
        <Button
          onClick={handleAddLigne}
          variant="outlined"
          className={global.greyButton}
          style={{ marginRight: spacing(2) }}

        >
          <AddRounded className={classes.add} /> Ajouter une nouvelle ligne
        </Button>
          <Button 
            onClick={formik.handleSubmit}
            disabled={isLoadingSaveBilling}
            variant="contained"
            color="primary"
          >
            Générer la facture
          </Button>
      </div>
    </div>
  );
};

const styles = ({ fontSizes, spacing }) => ({
  ligne: {
    textWrap: 'nowrap',
    color: "#92ABD2",
    fontSize: '14px',
    fontWeight: '500',
    marginRight: '32px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  divider: {
    marginBottom: "8px",
  },
  add: {
    marginRight: spacing(1),
  }
});

export default GenerateBilling;